/**
 * Created by alex.mccallum on 11/2/17.
 */

import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

// Services
import { JobsSearchService } from '../../services';

// Models
import { SelectedJob } from '../../models';
/**
 *
 * @class
 * JobsSearchResultsMapViewComponent
 *
 * @description
 * This component displays a list of jobs based on your search
 * There are two view types map and list
 *
 */
@Component({
  templateUrl: './jobs-search-results-job-listing.component.html',
  selector: 'jobs-search-results-job-listing',
  styleUrls: ['./jobs-search-results-job-listing.component.scss']
})
export class JobsSearchResultsJobListing implements OnInit {

  // Array array of job results from your search
  @Input() job: any;
  @Input() index: number;
  @Input() eventName: string;
  @Input() showDistance: boolean;
  @Input() showApply: boolean;
  @Input() themeColor: any;
  @Input() showShare: boolean = true;

  public selectedJob: SelectedJob;

  constructor(private jobSearchService: JobsSearchService) {}

  ngOnInit() {
    this.selectedJob = { job: this.job, index: this.index, eventName: this.eventName };
  }

  /**
   * Builds the category string for a single job, used on search results
   *
   * @param { any } - single row of the results we get back from the API search
   * @returns { string } - comma separated list of categories for a specific job
   */
  buildCategoryString(job: any): string {
    if (job.categories) {
      return job.categories.map(x => x).join(', ');
    }
  }

  /**
   * Given a job from the provided search results, build the address string
   * @param { any } job - job object from the results set
   */
  buildAddressString(job: any): string {
    return `${job.addressLine1} ${job.city}, ${job.stateProvCode}, ${job.postalCode}`;
  }

  /**
   * Job click handler
   *
   * @param { SelectedJob } - an object consisting of the job object, it's index, and the tracking event name
   */
  searchResultClick(selectedJob: SelectedJob) {
    this.jobSearchService.selectJob(selectedJob);
  }

}
